<div class="player video-question-player">
  <div [attr.id]="playerId">
  </div>
</div>
